
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderCombinedReportGrid extends Serenity.EntityGrid<OrderCombinedReportRow, any> {
        protected getColumnsKey() { return OrderCombinedReportColumns.columnsKey; }
        protected getDialogType() { return OrderCombinedReportDialog; }
        protected getIdProperty() { return OrderCombinedReportRow.idProperty; }
        protected getInsertPermission() { return OrderCombinedReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderCombinedReportRow.localTextPrefix; }
        protected getService() { return OrderCombinedReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderCombinedReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;

        }
    }
}